module.exports = __webpack_public_path__ + "static/cells-75b4285c42a7af49e125286baa691db0.png";